import { useMemo } from 'react';

import {
  ASTRA_FEATURE_BANNER,
  INVOICING_FEATURE_BANNER,
  TAX_SERVICES_FEATURE_BANNER
} from '#client/constants/whatNewBanner';

import useAnnouncementBanner from './useAnnouncementBanner';
import useInvoicingBanner from './useInvoicingBanner';
import useTaxServicesBanner from './useTaxServicesBanner';

const bannerViewEventProps = {
  bannerType: 'banking_banner',
  bannerPosition: 'top'
};

const useMapBanner = (whatNewBanners) => {
  const {
    pill: astraPill,
    description: astraDescription,
    handleClose: handleCloseAstraBanner,
    shouldNotShowBanner: shouldNotShowAstraBanner,
    title: astraBannerTitle,
    variationName: astraBannerVariantName
  } = useAnnouncementBanner();
  const {
    handleClose: handleCloseInvoicingBanner,
    isShowInvoicingBanner,
    handleClickTryNow
  } = useInvoicingBanner();

  const {
    handleClose: handleCloseTaxServicesBanner,
    isShowTaxServicesBanner,
    handleGetStarted
  } = useTaxServicesBanner();

  const bannerInfo = useMemo(
    () => [
      {
        type: ASTRA_FEATURE_BANNER.type,
        isVisible: !shouldNotShowAstraBanner,
        imageUrl: '/s2/vector/online-maintenance-notifications.svg',
        title: astraBannerTitle,
        description: astraDescription,
        pill: astraPill,
        eventProps: {
          elementName: `what's_new_${astraBannerVariantName}`,
          ...bannerViewEventProps
        },
        handleClose: handleCloseAstraBanner
      },
      {
        type: INVOICING_FEATURE_BANNER.type,
        isVisible: isShowInvoicingBanner,
        title: 'Quickly create professional invoices',
        description: 'Free with your ZenBusiness Banking account.',
        pill: 'New!',
        eventProps: {
          elementName: 'invoicing_announcement',
          ...bannerViewEventProps
        },
        handleClose: handleCloseInvoicingBanner,
        buttonProps: {
          label: 'Get started',
          onClick: handleClickTryNow
        }
      },
      {
        type: TAX_SERVICES_FEATURE_BANNER.type,
        variant: 'promo',
        isVisible: isShowTaxServicesBanner,
        title: 'Get help filing business taxes',
        description: 'Avoid mistakes at tax time, plus get expert help with tax questions anytime.',
        eventProps: {
          elementName: 'tax_upsell_banking',
          bannerType: 'promo'
        },
        handleClose: handleCloseTaxServicesBanner,
        buttonProps: {
          label: 'Get started',
          onClick: handleGetStarted
        }
      }
    ],
    [
      shouldNotShowAstraBanner,
      isShowTaxServicesBanner,
      astraBannerTitle,
      astraDescription,
      astraPill,
      astraBannerVariantName,
      handleCloseAstraBanner,
      isShowInvoicingBanner,
      handleCloseInvoicingBanner,
      handleCloseTaxServicesBanner,
      handleGetStarted,
      handleClickTryNow
    ]
  );

  const bannerInfoInfoWithOrder = useMemo(
    () =>
      whatNewBanners
        .map(({ type, ...otherProps }) => {
          const banner = bannerInfo.find((item) => item.type === type && item.isVisible);

          if (banner) {
            return {
              ...banner,
              ...otherProps
            };
          }
          return null;
        })
        .filter(Boolean)
        .sort((a, b) => a.order - b.order), // Sort by the `order` field,,
    [bannerInfo, whatNewBanners]
  );

  return bannerInfoInfoWithOrder;
};

export default useMapBanner;
